import React from 'react';
import SetPasswordContainer from 'containers/SetPassword';

const SetPassword = (props) => {
  return  (
    <>
    <SetPasswordContainer {...props}/>
    </>
  );
};

export default SetPassword;
